import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { IMAGES } from '../lib/content';
import { X } from 'lucide-react';

// Tetris-style grid: varied aspect ratios
const ASPECTS = [
  'aspect-[3/4]',
  'aspect-[4/5]',
  'aspect-[3/4]',
  'aspect-[1/1]',
  'aspect-[4/5]',
  'aspect-[3/4]',
  'aspect-[3/4]',
  'aspect-[4/5]',
  'aspect-[1/1]',
  'aspect-[3/4]',
  'aspect-[4/5]',
  'aspect-[3/4]',
];

export default function Gallery() {
  const [lightbox, setLightbox] = useState(null);

  return (
    <div>
      <section className="max-w-7xl mx-auto px-6 md:px-12 pt-16 md:pt-24 pb-12">
        <div className="font-label text-zb-accent mb-6">Gallery</div>
        <div className="flex items-end justify-between flex-wrap gap-6">
          <h1 className="font-serif text-5xl md:text-7xl text-zb-ink tracking-tight leading-[0.95]">
            Come a little <span className="italic text-zb-brand">closer.</span>
          </h1>
          <p className="text-zb-ink2 max-w-sm text-base leading-relaxed">
            Honest, unfiltered, and wholly mine. Click any image to linger.
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-12 pb-24">
        <div className="columns-2 md:columns-3 lg:columns-4 gap-3 md:gap-5 [column-fill:_balance]">
          {IMAGES.gallery.map((src, i) => (
            <button
              key={i}
              onClick={() => setLightbox(src)}
              data-testid={`gallery-item-${i}`}
              className={`zb-img-wrap ${ASPECTS[i % ASPECTS.length]} mb-3 md:mb-5 block w-full break-inside-avoid cursor-zoom-in zb-fade-up`}
              style={{ animationDelay: `${(i % 6) * 0.08}s` }}
            >
              <img src={src} alt={`Zahra Belle portrait ${i + 1}`} loading="lazy" />
            </button>
          ))}
        </div>

        <div className="mt-20 md:mt-24 text-center">
          <div className="font-label text-zb-accent mb-5">Like what you see?</div>
          <h2 className="font-serif text-4xl md:text-6xl text-zb-ink leading-tight">
            I&rsquo;m better in <span className="italic text-zb-brand">person.</span>
          </h2>
          <p className="mt-5 text-zb-ink2 text-base max-w-lg mx-auto leading-relaxed">
            Photographs flatter, but they can&rsquo;t kiss back.
          </p>
          <Link
            to="/contact"
            data-testid="gallery-cta-book"
            className="inline-block mt-10 rounded-full bg-zb-brand hover:bg-zb-brandHover text-zb-bg px-10 py-4 text-xs tracking-[0.22em] uppercase transition-colors"
          >
            Make a booking
          </Link>
        </div>
      </section>

      {lightbox && (
        <div
          data-testid="gallery-lightbox"
          onClick={() => setLightbox(null)}
          className="fixed inset-0 z-[90] bg-zb-ink/90 backdrop-blur-xl flex items-center justify-center p-6"
        >
          <button
            onClick={() => setLightbox(null)}
            aria-label="Close"
            data-testid="gallery-lightbox-close"
            className="absolute top-6 right-6 text-zb-bg hover:text-zb-brand"
          >
            <X size={28} />
          </button>
          <img
            src={lightbox}
            alt=""
            className="max-h-[88vh] max-w-[92vw] object-contain shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </div>
  );
}
